import React, { useContext } from 'react'
import { string } from 'prop-types'
import classNames from 'classnames'

import ProductsContainer from 'containers/designSidepanel/ProductsContainer'
import ProductFilterContainer from 'containers/designSidepanel/ProductFilterContainer'
import ProductDetailsViewContainer from 'containers/designSidepanel/ProductDetailsViewContainer'
import * as modes from 'models/ui/constants'

import SugarcubeContext from 'apps/SugarcubeContext'

require('./ProductBrowseView.scss')

const ProductBrowseView = ({ mode }) => {
    const isDetailsVisible = mode === modes.DESIGN_SIDEPANEL_MODE_PRODUCT_DETAILS

    const { isMobile } = useContext(SugarcubeContext)

    return (
        <div className="ProductBrowse">
            {isDetailsVisible && (
                <div className={classNames('detailsWrapper', { isDetailsVisible })}>
                    <ProductDetailsViewContainer />
                </div>
            )}
            <div className={classNames('browseWrapper', { isBrowseVisible: !isDetailsVisible })}>
                {!isMobile && <ProductFilterContainer />}
                <div className="itemSelection">
                    <div className="items">
                        <ProductsContainer />
                    </div>
                </div>
            </div>
        </div>
    )
}

ProductBrowseView.propTypes = {
    mode: string.isRequired,
}

export default ProductBrowseView
